<div class="bk-page wz">
  <header class="bk-page__head wz__head">
    <div class="bk-page__intro">
      <p class="bk-eyebrow">Campaigns</p>
      <h1 class="bk-page__title">New campaign</h1>
      <p class="bk-page__sub">{{ copy.sub }}</p>
    </div>
  </header>

  <!-- Step rail: done steps can be reopened, later ones wait their turn -->
  <nav class="wz-rail" aria-label="Campaign steps">
    <ol class="wz-rail__list">
      @for (item of steps; track item.slug; let i = $index) {
        <li class="wz-rail__step" [attr.data-state]="stateOf(i)">
          @if (stateOf(i) === "done" || stateOf(i) === "open") {
            <button type="button" class="wz-rail__btn" (click)="goTo(item.slug)">
              <span class="wz-rail__mark" aria-hidden="true">
                @if (stateOf(i) === "done") {
                  <span class="bk-sym">check</span>
                } @else {
                  {{ i + 1 }}
                }
              </span>
              <span class="wz-rail__label">{{ labelOf(item.slug) }}</span>
              @if (stateOf(i) === "done") {
                <span class="bk-sr-only">(done)</span>
              }
            </button>
          } @else {
            <span
              class="wz-rail__btn"
              [attr.aria-current]="stateOf(i) === 'current' ? 'step' : null"
              [attr.aria-disabled]="stateOf(i) === 'locked' ? 'true' : null"
            >
              <span class="wz-rail__mark" aria-hidden="true">{{ i + 1 }}</span>
              <span class="wz-rail__label">{{ labelOf(item.slug) }}</span>
            </span>
          }
        </li>
      }
    </ol>
    <p class="wz-rail__count" aria-hidden="true">
      Step {{ currentIndex + 1 }} of {{ steps.length }} · <strong>{{ labelOf(steps[currentIndex].slug) }}</strong>
    </p>
  </nav>

  @if (duplicator.sourceName) {
    <p class="wz__note">
      <span class="bk-sym" aria-hidden="true">content_copy</span>
      <span>
        Copied from <strong>“{{ duplicator.sourceName }}”</strong>. The audience and messages are filled in;
        choose new dates and send times before you launch.
        @if (duplicator.droppedSegments) {
          {{ duplicator.droppedSegments === 1 ? "One segment" : duplicator.droppedSegments + " segments" }} couldn’t be
          copied, so choose {{ duplicator.droppedSegments === 1 ? "it" : "them" }} again in Recipients.
        }
      </span>
    </p>
  }

  <h2 class="bk-sr-only" tabindex="-1" #stepTitle>
    Step {{ currentIndex + 1 }} of {{ steps.length }}: {{ labelOf(steps[currentIndex].slug) }}
  </h2>

  <div class="wz__body">
    @if (step === "campaign-details" || step === null) {
      <app-campaign-details></app-campaign-details>
    } @else if (step === "recipients") {
      <app-recipients></app-recipients>
    } @else if (step === "messages") {
      <app-messages></app-messages>
    } @else if (step === "schedule") {
      <app-schedule></app-schedule>
    } @else if (step === "review") {
      <app-review></app-review>
    }
  </div>
</div>

@if (this.cancelCampaignService.cancel) {
  <app-prompt-card
    [openModal]="this.cancelCampaignService.cancel"
    title="Discard this campaign?"
    buttonText="Discard campaign"
    closeText="Keep editing"
    (onClose)="this.cancelCampaignService.closeCancelModal()"
    (onButtonClick)="cancelCampaignCreation()"
  >
    <p class="wz__prompt">
      Nothing has been saved yet. Discarding clears every step, and you start again from the beginning.
    </p>
  </app-prompt-card>
}
